export default __webpack_public_path__ + "static/media/gift-cards.inline.5b824bf2.svg";